import React from 'react'
import Switch from '@material-ui/core/Switch'
import { withStyles } from '@material-ui/core/styles'

const PurpleSwitch = withStyles({
  switchBase: {
    '&$checked': {
      color: '#52d869',
    },
    '&$checked + $track': {
      backgroundColor: '#52d869',
    },
  },
  checked: {},
  track: {},
})(Switch)

export default (props) => {
  const handleChange = (input) => {
    props.onChange(input.currentTarget.checked)
  }

  return (
    <PurpleSwitch
      disabled={props.disabled}
      className={props.className}
      checked={Boolean(props.value)}
      onChange={handleChange}
      inputProps={{ 'aria-label': 'enabled message history' }}
    />
  )
}
